// @flow
/**
 * @module Actions/Categoria
 * @desc Actions for Categoria
 */
import { ActionTypes } from '../utils/constants';

/**
 * Fetch categorias request
 * @param {string} marca
 * @returns {Object}
 */
export function fetchCategoriasRequest(marca: String) {
  return {
    type: ActionTypes.FETCH_CATEGORIAS_REQUEST,
    payload: { marca }
  };
}

/**
 * Fetch categorias success
 *
 * @param {array} categorias
 * @returns {Object}
 */
export function fetchCategoriasSuccess(categorias: Array, extraInfo: any) {
  return {
    type: ActionTypes.FETCH_CATEGORIAS_SUCCESS,
    payload: { categorias, extraInfo },
  };
}

/**
 * Fetch categorias failure
 *
 * @returns {Object}
 */
export function fetchCategoriasFailure() {
  return {
    type: ActionTypes.FETCH_CATEGORIAS_FAILURE,
  };
}

/**
 * Fetch categoria request
 * @param {String} categoriaId
 * @returns {Object}
 */
export function fetchCategoriaRequest(categoriaId: string) {
  return {
    type: ActionTypes.FETCH_CATEGORIA_REQUEST,
    payload: { categoriaId },
  };
}

/**
 * Fetch categoria success
 *
 * @param {object} categoria
 * @returns {Object}
 */
export function fetchCategoriaSuccess(categoria: Object) {
  return {
    type: ActionTypes.FETCH_CATEGORIA_SUCCESS,
    payload: { categoria },
  };
}

/**
 * Fetch categoria success
 *
 * @returns {Object}
 */
export function fetchCategoriaReset() {
  return {
    type: ActionTypes.FETCH_CATEGORIA_RESET,
  };
}

/**
 * Fetch categoria failure
 *
 * @returns {Object}
 */
export function fetchCategoriaFailure() {
  return {
    type: ActionTypes.FETCH_CATEGORIA_FAILURE,
  };
}


export function saveInitialQueryparams(queryString) {
  return {
    type: ActionTypes.SAVE_INITIAL_QUERYPARAMS,
    payload: { queryString }
  }
}